import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

interface StyledFormProps {
  $isVisible: boolean;
}

export const StyledForm = styled.form<StyledFormProps>`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: ${pxToRem(500)};

  background: #ffffff;
  box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.1);
  border-radius: ${pxToRem(16)} ${pxToRem(16)} 0 0;
  z-index: 99999;

  display: ${props => (props.$isVisible ? 'block' : 'none')};
`

export const StyledContent = styled.div`
  padding: ${pxToRem(20)};
  display: flex;
  flex-direction: column;

  h1 {
    margin: 0 0 ${pxToRem(10)} 0;
  }

  p {
    margin: 0 0 ${pxToRem(15)} 0;
    color: #4a5568;
  }
`

export const StyledLang = styled.div`
  text-align: right;
  margin-bottom: ${pxToRem(10)};

  button {
    color: #718096;
    font-size: ${pxToRem(13.6)};
    padding: ${pxToRem(4)};

    &:hover {
      color: #1a202c;
    }
  }
`

export const StyledLink = styled.a`
  display: block;
  color: #3182ce;
  font-size: ${pxToRem(13.6)};
  margin-bottom: ${pxToRem(8)};
  text-decoration: underline;

  &:hover {
    color: #2b6cb0;
  }
`

export const StyledCheckboxes = styled.div`
  margin-top: ${pxToRem(15)};
  max-height: ${pxToRem(250)};
  overflow-y: auto;
  border-top: 1px solid #edf2f7;
  padding-top: ${pxToRem(10)};

  &::-webkit-scrollbar {
    width: ${pxToRem(5)};
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: ${pxToRem(3)};
  }

  .category-item {
    margin-bottom: ${pxToRem(15)};
  }

  .category-header,
  .service-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: ${pxToRem(5)} 0;
    gap: ${pxToRem(12)};
     
    & input {
      flex: initial;
    }
  }

  .service-header {
    padding: ${pxToRem(5)} 0 ${pxToRem(5)} ${pxToRem(5)};
    background: #f5f5f5;
  }

  .category-trigger {
    font-size: ${pxToRem(15.2)};
  }

  .service-trigger {
    font-size: ${pxToRem(13.6)};
  }

  .category-description {
    font-size: ${pxToRem(12.8)};
    color: #718096;
    margin: 0 0 ${pxToRem(16)};
  }

  .service-container {
    padding-left: ${pxToRem(15)};
    margin-top: ${pxToRem(10)};
  }
`

export const StyledButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(10)};
  margin-top: ${pxToRem(20)};
  border-top: 1px solid #edf2f7;
  padding-top: ${pxToRem(15)};

  > * {
    margin-top: ${pxToRem(8)};
    margin-bottom: ${pxToRem(4)};
  }

  .button-group {
    display: flex;
    gap: ${pxToRem(10)};
    flex-wrap: wrap;
    width: 100%;
  }

  .button-group > * {
    flex: 1;
    margin-top: ${pxToRem(4)};
    margin-bottom: ${pxToRem(8)};
  }

  .button-group.button-group button {
    white-space: nowrap; 
    word-break: normal;
  }
`